import { useState, useEffect } from "react";
import axios from "axios"


import GlobalStyle from "../../styles/global3.js";
import styled from "styled-components";
import "react-toastify/dist/ReactToastify.css";
import { toast, ToastContainer } from "react-toastify";

import GridPatio from "./components/Grid-patio.js";
import GridCampo from "./components/Grid-campo.js";
import GridObjetoCusto from "./components/Grid-objeto-custo.js";
import GridGeral from "./components/Grid-geral.js";
import { IoMdArrowBack } from "react-icons/io";


import fundo from "../../styles/fundo.svg";
import logo1 from "../../styles/imagem/logo-1.png";
import logo2 from "../../styles/imagem/logo-2.png";
import logo3 from "../../styles/imagem/logo-3.png";
import logo4 from "../../styles/imagem/logo-4.png";
import logo5 from "../../styles/imagem/logo-5.png";


const Div = styled.div`
  display: flex;
  overflow: auto;
  flex-direction: column;

`;
const DivBody = styled.div`
  display: flex;
  overflow: auto;
  flex-direction: column;
  width: 90%;
  border-radius: 15px;
`;

const DivAba = styled.div`
  display: flex;
  overflow: auto;
  flex-direction: column;
  width: 100%;
    box-shadow: 0px 0px 2px #ccc;
`;

const DivLayout = styled.div`
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

`;

const Container = styled.div`
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center; 
  align-items: center;
  box-sizing: border-box;
  margin-bottom: 100px;

`;

const Title = styled.nav`
  width: 100%;
  display: flex;
  justify-content: space-between; 
  align-items: center;
  height: 4.0rem;
  background-image: url(${fundo});
`;

const Title2 = styled.h2`
  display: flex;
  justify-content: space-between; 
  align-items: center;
  width: 55%;
  color: #fff;
  font-size: 28px;

  @media (max-width: 768px) {
    font-size: 20px;
    width: 90%;
  }

`;

const DivTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center; 

    @media (max-width: 768px) {
      font-size: 16px;

    }
`;



const ButtonSair = styled.button`
  padding: 10px 20px 20px 20px;
  cursor: pointer;
  border-radius: 3px;
  border: none;
  background-color: transparent;
  color: white;
  height: 45px;
  font-weight: bold;
  font-size: 28px;
  margin: 5px;
  transition: transform 0.3s;
  &:hover {
    transform: scale(1.2);
  }

`;



const TabsSelect = styled.select`
  padding: 10px;
  font-size: 16px;
  border-radius: 6px;
  border: 1px solid #ccc;
  background-color: #fff;
  font-weight: bold;
  margin: 10px 0px;
  width: 80%;

  @media (min-width: 780px) {
    display: none; 

  }
`;

const TabsContainer = styled.div`

  display: flex;
  margin: 10px 0px;
  gap: 10px;

  @media (max-width: 779px) {
    display: none; // esconde os botões no mobile
  }
`;




const Imagem = styled.img`
  width: 600px;
  height: auto;

  @media (max-width: 768px) {
    width: 200px;
    height: auto;
  }
`;


export const TabButton = styled.button`
  flex: 1 1 auto;
  padding: 10px 20px;
  font-weight: bold;
  border: none;
  cursor: pointer;
  background-color: ${({ active }) => (active ? "#fff" : "#f1f1f1")};
  background-image: ${({ active }) => (active ? `url(${fundo})` : "none")};
  background-size: cover;
  background-position: center;
  color: ${({ active }) => (active ? "#fff" : "#333")};
  border-radius: 6px;
  transition: all 0.3s ease;
  border: 1px solid #ccc;
  width: 250px;
  &:hover {
    background-color: ${({ active }) => (active ? "#fff" : "#e0e0e0")};
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px #076333;
  }

  @media (max-width: 768px) {
    flex: 0 0 48%; // 2 colunas com pequeno espaçamento
  }

  @media (max-width: 480px) {
    flex: 0 0 48%; // 1 coluna total em telas muito pequenas
  }
`;



function Usuarios() {

  const urlFront = process.env.REACT_APP_FRONT_URL;
  const urlApi = process.env.REACT_APP_API_URL;

  const token = localStorage.getItem('token');







  //----------------------------------------------------------//
  const handleVoltar = () => {
    window.location.href = urlFront;
  };


  //---------------------IMAGEM DE CARREGANDO-----------//
  const [abaAtiva, setAbaAtiva] = useState("");
  const [loadingImage, setLoadingImage] = useState(null);

  const imagens = [logo1, logo2, logo3, logo4, logo5];


  const trocarAbaComImagem = (novaAba) => {
    const imagemAleatoria = imagens[Math.floor(Math.random() * imagens.length)];
    setLoadingImage(imagemAleatoria);

    setTimeout(() => {
      setLoadingImage(null);
      setAbaAtiva(novaAba);
    }, 1000); // 1.0 segundos de exibição
  };

  useEffect(() => {
    trocarAbaComImagem("osObjetoCusto"); // define o nome da aba ativa
  }, []);

  //--------------------------------------------FUNÇÂO AS OS------------------------------------//
  const [osObjetoCusto, setOsObjetoCusto] = useState([]);
  const [osPatio, setOsPatio] = useState([]);
  const [osCampo, setOsCampo] = useState([]);
  const [osGeral, setGeral] = useState([]);

  const [tipoCampo, setTipoCampo] = useState([]);
  const [tipoPatio, setTipoPatio] = useState([]);
  const [tipoGeral, setTipoGeral] = useState([]);

  const [totalOsOb, setTotalOsOb] = useState('');
  const [totalOsPatio, setTotalOsPatio] = useState('');
  const [totalOsCampo, setTotalOsCampo] = useState('');
  const [totalOsGeral, setTotalOsGeral] = useState('');

  const [loading, setLoading] = useState(false);

  const fetchOs = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${urlApi}acompanhamento-os/listar-os-por-objetocusto`);
      setOsObjetoCusto(res.data);

      const res1 = await axios.get(`${urlApi}acompanhamento-os/listar-os-no-patio`);
      setOsPatio(res1.data);

      const res2 = await axios.get(`${urlApi}acompanhamento-os/listar-os-no-campo`);
      setOsCampo(res2.data);

      const res3 = await axios.get(`${urlApi}acompanhamento-os/listar-tipo-campo`);
      setTipoCampo(res3.data);

      const res4 = await axios.get(`${urlApi}acompanhamento-os/listar-tipo-patio`);
      setTipoPatio(res4.data);

      const res5 = await axios.get(`${urlApi}acompanhamento-os/listar-geral`);
      setGeral(res5.data);

      const res6 = await axios.get(`${urlApi}acompanhamento-os/listar-tipo-geral`);
      setTipoGeral(res6.data);

      const res7 = await axios.get(`${urlApi}acompanhamento-os/listar-total-os-por-objetocusto`);
      setTotalOsOb(res7.data);

      const res8 = await axios.get(`${urlApi}acompanhamento-os/listar-total-os-por-patio`);
      setTotalOsPatio(res8.data);

      const res9 = await axios.get(`${urlApi}acompanhamento-os/listar-total-os-por-campo`);
      setTotalOsCampo(res9.data);

      const res10 = await axios.get(`${urlApi}acompanhamento-os/listar-total-os-por-geral`);
      setTotalOsGeral(res10.data);

    } catch (error) {
      console.error('Erro ao buscar dados das OS:', error);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    fetchOs();
  }, [])






  return (
    <>
      <Div>
        <DivLayout>
          <Title>
            <Title2>
              <DivTitle>

                <DivTitle>
                  <ButtonSair onClick={handleVoltar} title="Voltar">
                    <IoMdArrowBack />
                  </ButtonSair>
                  <h2>Ordem de Serviço da Oficina</h2>

                </DivTitle>
              </DivTitle>

            </Title2>
          </Title>
        </DivLayout>

        <Container>
          <TabsContainer>
            <TabButton active={abaAtiva === "osObjetoCusto"} onClick={() => trocarAbaComImagem("osObjetoCusto")}>Objeto Custo</TabButton>
            <TabButton active={abaAtiva === "osPatio"} onClick={() => trocarAbaComImagem("osPatio")}>Pátio</TabButton>
            <TabButton active={abaAtiva === "osCampo"} onClick={() => trocarAbaComImagem("osCampo")}>Campo</TabButton>
            <TabButton active={abaAtiva === "osGeral"} onClick={() => trocarAbaComImagem("osGeral")}>Geral</TabButton>

          </TabsContainer>
          <TabsSelect value={abaAtiva} onChange={(e) => trocarAbaComImagem(e.target.value)}>
            <option value="osObjetoCusto">Objeto Custo</option>
            <option value="osPatio">Pátio</option>
            <option value="osCampo">Campo</option>
            <option value="osGeral">Geral</option>
          </TabsSelect>
          <DivBody>




            {loadingImage ? (
              <div style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "82vh",           // altura total da tela
                width: "100%",
                textAlign: "center"
              }}>
                <Imagem
                  src={loadingImage}
                  alt="Carregando..."
                  style={{
                    animation: "zoomIn 0.8s ease-out forwards"
                  }}
                />

                <style>
                  {`
                      @keyframes zoomIn {
                        from {
                          opacity: 0;
                          transform: scale(0.8);
                        }
                        to {
                          opacity: 1;
                          transform: scale(1);
                        }
                      }
                    `}
                </style>
              </div>
            ) : (
              <DivAba>
                {abaAtiva === "osObjetoCusto" && <GridObjetoCusto urlApi={urlApi} osObjetoCusto={osObjetoCusto} totalOsOb={totalOsOb} />}
                {abaAtiva === "osPatio" && <GridPatio urlApi={urlApi} osPatio={osPatio} tipoPatio={tipoPatio} totalOsPatio={totalOsPatio} />}
                {abaAtiva === "osCampo" && <GridCampo urlApi={urlApi} osCampo={osCampo} tipoCampo={tipoCampo} totalOsCampo={totalOsCampo} />}
                {abaAtiva === "osGeral" && <GridGeral urlApi={urlApi} osGeral={osGeral} tipoGeral={tipoGeral} totalOsGeral={totalOsGeral} />}


              </DivAba>
            )}



            <ToastContainer autoClose={2500} position={toast.POSITION.BOTTOM_LEFT} style={{ width: '400px', fontSize: '22px' }} />

          </DivBody>
        </Container>

      </Div>
      <GlobalStyle />
    </>
  );
}

export default Usuarios;
